import { format } from "date-fns"

/**
 * Format epoch timestamp as a readable date string
 * @param timestamp - Unix timestamp in seconds
 * @returns Formatted date string (e.g., "Jan 15th 2026") or "N/A" if invalid
 */
export const formatEpochDate = (timestamp: number | undefined | null): string => {
  if (timestamp === undefined || timestamp === null || isNaN(Number(timestamp))) {
    return "N/A"
  }
  return format(new Date(Number(timestamp) * 1000), "MMM do yyyy")
}

/**
 * Format epoch timestamp as a full timestamp string
 * @param timestamp - Unix timestamp in seconds
 * @returns Formatted timestamp string (e.g., "01/15/2026, 12:34:56") or "N/A" if invalid
 */
export const formatEpochTimestamp = (timestamp: number | undefined | null): string => {
  if (timestamp === undefined || timestamp === null || isNaN(Number(timestamp))) {
    return "N/A"
  }
  return format(new Date(Number(timestamp) * 1000), "MM/dd/yyyy, HH:mm:ss")
}

/**
 * Format epoch integer value as a localized string with thousand separators
 * @param value - String or number value to format
 * @returns Formatted integer string (e.g., "32,856") or "0" if invalid
 */
export const formatEpochInteger = (value: string | undefined | null): string => {
  if (value === undefined || value === null || value === "") {
    return "0"
  }
  const numValue = Number(value)
  if (isNaN(numValue)) {
    return "0"
  }
  return Math.floor(numValue).toLocaleString("en-US", { maximumFractionDigits: 0 })
}

/**
 * Format epoch percentage value as a string with 2 decimal places
 * @param value - Percentage value (0-100)
 * @returns Formatted percentage string (e.g., "17.12%") or "N/A" if invalid
 */
export const formatEpochPercentage = (value: number | undefined | null): string => {
  if (value === undefined || value === null || isNaN(Number(value))) {
    return "N/A"
  }
  return `${Number(value).toFixed(2)}%`
}
